import { clsx } from 'clsx'

import { Dashboard } from '../../models/Dashboard'
import { User } from '../../models/User'
import { getDashboardIcon } from '../../utils/dashboard'
import { Icon } from '../Icon'
import Heading from '../app/design/Heading'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import Tag from '../app/design/Tag'
import { Clickable } from '../common/Clickable'

export function LinkMetricDisplay({ dashboard }: { dashboard: Dashboard }) {
    if (!dashboard.metric) return null

    const firstChar = dashboard.metric[0]

    return (
        <Tag
            label={`${dashboard.metric}`}
            intent={firstChar === '-' ? 'danger' : 'success'}
            size="sm"
            className="hidden lg:block"
        />
    )
}

export function DashboardLink({ dashboard, client }: { dashboard: Dashboard; client?: User }) {
    return (
        <Clickable
            href={
                client
                    ? `/dashboards/${dashboard.id}?clientId=${client.id}`
                    : `/dashboards/${dashboard.id}`
            }
            className={clsx(
                'flex items-center justify-between rounded-lg bg-white px-4 py-4 text-gray-700 last:mb-4'
            )}
        >
            <div className="flex items-center gap-4">
                <Icon
                    icon={`${getDashboardIcon(dashboard.id)}.large`}
                    className="text-primary-700 shrink-0"
                    shouldInheritColor={true}
                    background="round"
                />
                <div>
                    <Label size="md" className="text-gray-700">
                        {dashboard.title}
                    </Label>
                    <Paragraph size="sm" className="text-gray-600">
                        {dashboard.status}
                    </Paragraph>
                </div>
            </div>

            <div className="flex items-center gap-4">
                <LinkMetricDisplay dashboard={dashboard} />
                <Heading size="sm">{dashboard.count || 0}</Heading>
            </div>
        </Clickable>
    )
}
